// A title, shown big — the live app's "Title Details" (Ben, Oct 20 2026: render titles the way the Unity front end does;
// chose "match the live app"). Front End Assets/PreFabs/MainContents/TitleInformationPopUp.prefab + MyTitle/TitlesPopUp.cs
// (feature/new-backend 516bd958): a "Title Details" heading, the badge (drawn live, the light following the tilt) inside
// the gilded picture frame (Resources/Titles/title_frame.png, the badge filling its opening: anchors x .226–.775,
// y .146–.800 from the top), then the name on the gold banner (Resources/Forge/banner_btn@2x.png, 9-sliced 21/22/24/21,
// dark Trajan-style caps). No painted portrait and no description — the app's popup has neither (its description text is
// switched off). The badge stays round in the frame's tall opening (the app stretches it to the opening). A short line
// (tier, worn, where it was earned) and any actions (Wear this title) come under the banner.
import type { ReactNode } from "react";
import { Sheet } from "@/kit/overlays";
import { titleName } from "@/game/titles";
import { TitleBadge } from "./TitleBadge";
import { useMotion } from "./badgeMotion";

export function TitleSheet({ title, tier, details, onClose, note, children }: {
  title: string | null;
  tier?: number | null;
  details: Record<string, unknown> | undefined;
  onClose: () => void;
  /** a line under the banner, e.g. "Tier 3 · worn" or "Not earned yet" */
  note?: ReactNode;
  children?: ReactNode;
}) {
  const name = title ? titleName(title, details) : "Title";
  const askable = useMotion((m) => m.askable);
  const ask = useMotion((m) => m.ask);
  return (
    <Sheet open={!!title} onClose={onClose} label={name} title={<h3 className="eyebrow tt-details-h">Title Details</h3>}>
      {title && (
        <div className="stack" style={{ gap: 12 }}>
          <div className="tt-frame">
            <span className="tt-frame-hole">
              <TitleBadge key={`${title}-${tier ?? 0}`} title={title} tier={tier} details={details} live className="tt-show-badge" />
            </span>
            <img className="tt-frame-art" src="/badge/title-frame.webp" alt="" decoding="async" draggable={false} />
          </div>
          <div className="tt-banner"><h3>{name}</h3></div>
          {(note || askable) && (
            <div className="tt-show-name">
              {note && <span>{note}</span>}
              {askable && <button type="button" className="link tt-tilt" onClick={() => void ask()}>Tilt with your phone</button>}
            </div>
          )}
          {children}
        </div>
      )}
    </Sheet>
  );
}
